import http from '../../utils/http';

export default {
    /**
     * 获取指定分类的下级分类
     *
     * @param {*} data
     * @returns
     */
    getProfessionalCategoryByParent(data) {
        return http({
            url: 'Course/GetProfessionalCategoryByParent',
            params: data
        });
    }
};
